/** @jsxImportSource theme-ui */
import React, { useState } from 'react';

import AdminApi from 'api/AdminApi';
import { sxtheme } from 'utils/cssHelpers';
import { shortenUrl } from 'utils/urlHelpers';

import { Typography } from 'components/_common/Typography';
import BdButton from 'components/_controls/BdButton/BdButton';
import { BdFormSection } from 'components/SidebarView/SettingsView/_common/BdFormLabel';

type ResetPasswordSectionProps = {
  userId: string;
  isExternal?: boolean;
};

const ResetPasswordSection: React.FC<ResetPasswordSectionProps> = ({
  userId,
  isExternal = false,
}) => {
  const [resetPasswordLink, setResetPasswordLink] = useState(null);
  const [isGettingLink, setIsGettingLink] = useState(false);

  const getResetPasswordUrl = () => {
    setIsGettingLink(true);
    AdminApi.getResetPasswordLink(userId)
      .then(result => {
        setResetPasswordLink(result);
      })
      .finally(() => {
        setIsGettingLink(false);
      });
  };

  return (
    <BdFormSection>
      <div sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <BdButton
          type="tertiary"
          sx={{ width: '250px' }}
          text={isGettingLink ? 'Generating Link...' : 'Generate Reset Password Link'}
          onClick={getResetPasswordUrl}
          disabled={isExternal || isGettingLink}
        />
        {!!resetPasswordLink && !isGettingLink && (
          <a href={resetPasswordLink} target="_blank" rel="noopener noreferrer">
            <Typography
              variant="body2"
              color="deepSea70"
              inline
              sx={{
                textDecoration: 'underline',
                '&:hover': {
                  color: sxtheme(t => t.colors.sea90),
                },
              }}
            >
              {shortenUrl(resetPasswordLink)}
            </Typography>
          </a>
        )}
        {isExternal && (
          <Typography variant="body2" color="stone90">
            Cannot reset password. User is part of external authentication.
          </Typography>
        )}
      </div>
    </BdFormSection>
  );
};

export default ResetPasswordSection;
